import React from 'react';
import { batch } from 'react-redux';
import { addIndication, INDICATION_TYPES } from 'modules/taboola-common-frontend-modules/Indications';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import landingPagesApi from 'services/api/landingPagesApi';
import { errorMessagesUtils } from 'services/utils';
import {
    deleteLandingPageError,
    deleteLandingPageSuccess,
    requestDeleteLandingPage,
} from '../actions/deleteLandingPage';

export const successIndication = {
    type: INDICATION_TYPES.SUCCESS,
    message: <FormattedMessage id="landing.pages.delete.success" defaultMessage="Advertorial successfully deleted" />,
    highlight: <FormattedMessage id="success.highlight" defaultMessage="Success!" />,
};

export const generateErrorIndication = errorObject => ({
    type: INDICATION_TYPES.ERROR,
    message: errorMessagesUtils.getErrorMessage(errorObject),
    highlight: <FormattedMessage id="landing.pages.delete.error" defaultMessage="Unable to delete Advertorial" />,
});

export const deleteLandingPage = landingPage => async dispatch => {
    dispatch(requestDeleteLandingPage());

    try {
        const response = await landingPagesApi.deleteLandingPage(landingPage);
        batch(() => {
            dispatch(deleteLandingPageSuccess(response));
            dispatch(addIndication(successIndication));
        });
        return response;
    } catch (error) {
        batch(() => {
            dispatch(addIndication(generateErrorIndication(error)));
            dispatch(deleteLandingPageError({ id: landingPage.id, error }));
        });
    }
};
